<template>
  <v-app-bar 
    app 
    clipped-left
    height="70" 
    color="#1A237E" 
    dark 
    elevation="4"
  >
    <v-app-bar-nav-icon 
      class="hidden-lg-and-up" 
      @click.stop="$emit('toggle-drawer')"
    ></v-app-bar-nav-icon>

    <div class="d-flex align-center ml-2" style="cursor: pointer" @click="$router.push('/dashboard')">
      <v-img
        src="../assets/images/W.png"
        contain
        height="35"
        width="35"
        class="mr-3"
      ></v-img>
      <span class="brand-title">Whale Shark Portal</span>
    </div>

    <v-spacer></v-spacer>

    <div class="d-flex align-center mr-4">
      <v-menu bottom left offset-y transition="slide-y-transition" rounded="lg">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" large class="profile-btn">
            <v-avatar color="rgba(255,255,255,0.1)" size="40">
              <v-icon color="white">mdi-account</v-icon>
            </v-avatar>
          </v-btn>
        </template>

        <v-list dense width="200" class="py-0">
          <v-list-item class="grey lighten-4 py-2">
            <v-list-item-content>
              <v-list-item-title class="navy--text font-weight-black">Administrator</v-list-item-title>
              <v-list-item-subtitle class="caption">Marine Management</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="logout" class="py-2">
            <v-list-item-icon class="mr-3"><v-icon color="red">mdi-power</v-icon></v-list-item-icon>
            <v-list-item-title class="red--text font-weight-bold">Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </v-app-bar>
</template>

<script>
  import store from '@/store'; 
  
  export default {
    name: 'AppHeader',
    methods: {
      logout() {
        // 2. Use the imported store object instead of this.$store
        store.commit("logoutUser");
      },
      goHome() {
        // Ensuring it goes to the correct admin root
        this.$router.push("/admin").catch(() => {});
      }
    }
  };
  </script>

<style scoped>
.brand-title {
  font-family: 'Syne', sans-serif;
  font-weight: 800;
  font-size: 18px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
}
.profile-btn {
  border: 1px solid rgba(255,255,255,0.2) !important;
}
.navy--text {
  color: #1A237E;
}
</style>